import AutoAwesome from '@mui/icons-material/AutoAwesome';
import { ListingMock } from '../components/ListingMock';
import { JobFitReportMock } from '../components/JobFitReportMock';
import {
  Container,
  Hero,
  HeroBadge,
  HeroBadgeRow,
  HeroContent,
  HeroSubtitle,
  HeroTitle,
  Section,
  SectionCard,
  SectionHeader,
  StepCard,
  StepsGrid,
} from './styles';

const steps = [
  {
    n: '01',
    title: 'Avaliação já existente',
    description: 'Utilizamos o laudo gerado no fluxo atual.',
  },
  {
    n: '02',
    title: 'Match com o cargo',
    description: 'Comparamos com os requisitos do cargo alvo.',
  },
  {
    n: '03',
    title: 'Score de aderência',
    description: 'Um número de 0 a 100 aparece na listagem.',
  },
  {
    n: '04',
    title: 'Relatório completo',
    description: 'PDI, radar e camadas MCG em um único documento.',
  },
];

export const JobFitPreview = () => {
  return (
    <Container>
      <Hero>
        <HeroContent>
          <HeroBadgeRow>
            <HeroBadge
              icon={<AutoAwesome />}
              label="Novidade — Em breve"
              size="small"
            />
            <HeroBadge label="MCG v4.1" size="small" />
          </HeroBadgeRow>

          <HeroTitle>
            JobFit MS: o match entre candidato e vaga, utilizando o nosso laudo.
          </HeroTitle>

          <HeroSubtitle>
            Aproveitamos as avaliações já realizadas no sistema para gerar
            automaticamente o <strong>Job Fit Report</strong> — com score de
            aderência, comparativo com o Cargo DNA e PDI sugerido.
          </HeroSubtitle>
        </HeroContent>
      </Hero>

      <SectionCard>
        <h2>Como o JobFit funciona</h2>
        <div className="section-subtitle">
          Não é necessário aplicar um novo teste: o laudo já disponível no
          sistema alimenta o Job Fit Report.
        </div>

        <StepsGrid>
          {steps.map((step) => (
            <StepCard key={step.n}>
              <div className="step-number">PASSO {step.n}</div>
              <div className="step-title">{step.title}</div>
              <div className="step-description">{step.description}</div>
            </StepCard>
          ))}
        </StepsGrid>
      </SectionCard>

      <Section>
        <SectionHeader>
          <div>
            <div className="section-eyebrow">
              1 · Na sua listagem de avaliações
            </div>
            <h2>Nova coluna JobFit</h2>
            <div className="section-description">
              O score de <strong>JobFit</strong>, calculado por IA a partir do
              laudo, aparece na tabela — com atalho direto para o relatório
              completo.
            </div>
            <div className="section-note">* Nomes fictícios</div>
          </div>
        </SectionHeader>

        <ListingMock />
      </Section>

      <Section>
        <SectionHeader>
          <div>
            <div className="section-eyebrow">
              2 · Ao abrir o relatório de JobFit do candidato
            </div>
            <h2>Prévia do Job Fit Report</h2>
            <div className="section-description">
              Dados fictícios, apenas para ilustrar o formato final do
              documento.
            </div>
          </div>
        </SectionHeader>

        <JobFitReportMock />
      </Section>
    </Container>
  );
};
